import React, { useEffect, useState } from 'react';
import useSedi from '../../../hooks/useSedi';
import { Spinner } from 'react-bootstrap';
import TitoloStudioOptions from '../../../model/titoliDiStudio';
import useCorsi from '../../../hooks/useCorsi';
import UtilityService from '../../../services/UtillityServices/UtilityService';
import { useNavigate } from 'react-router';
import CustomModal from '../../../components/CustomModal/CustomModal';
import { alertService } from '../../../services/AlertService';
import RequirementsCourse from '../../RequirementsCourse/RequirementsCourse';
import useMediaQuery from '../../../hooks/useMediaQuery';
import CustomSearch from '../../CustomSearch/CustomSearch';
import useCertificazioni from '../../../hooks/useCertificazioni';
import RichTextEditor from '../../RichTextEditor/RichTextEditor';
import { TIPO_CORSO } from '../../../model/tipoCorso';

const CreateCorsoForm = ({setPercBar, courseDataEdit, isUpdateMode}) => {
  const navigate = useNavigate();
  const {addDocumentCorsi, deleteDocumentCorsi, findDocumentiByIdCorso} = useCorsi();
  const [formData, setFormData] = useState({});
  const [formDataDocument, setFormDataDocument] = useState([]);
  const [modalita, setModalita] = useState(courseDataEdit?.modalita_erogazione ? UtilityService.formatModalitaErogazionePerCheckbox(courseDataEdit?.modalita_erogazione)  : 'sincrona');
  const {loadingStateSedi, getAllSedi} = useSedi();
  const {loadingStateCorsi, createCorso, updateCorso} = useCorsi();
  const [currentPage, setCurrentPage] = useState(1);
  const [createdCorso, setCreatedCorso] = useState(null);
  const isMax900px = useMediaQuery('(max-width: 900px)');

  const [sedi, setSedi] = useState([]);
  const [selectedTitoloStudioMinimo, setTitoloStudioMinimo] = useState('');
  const [selectedTipoCorso, setTipoCorso] = useState('');
  const [imageBlob, setImageBlob] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [deleteDocumentiList, setDeleteDocumentiList] = useState([]);
  const [isLoadingCreateDocument, setIsLoadingCreateDocument] = useState(false);
  const [isLoadingDeleteDocument, setIsLoadingDeleteDocument] = useState(false);
  const [isLoadingAllDocuments, setIsLoadingAllDocuments] = useState(false);
  const { getCertificazioniByParams } = useCertificazioni();
  const [selectedCertificazione, setSelectedCertificazione] = useState(courseDataEdit?.certificazione || null);

  useEffect(() => {
    if(courseDataEdit?.id_corso) {
      fetchDocumentiByIdCorso();
      setImageUrl(courseDataEdit?.immagine_corso)
      const obj = {
        ...courseDataEdit
      }
      delete obj.immagine_corso 
      setFormData(obj)
      
      if (courseDataEdit.certificazione) {
        setSelectedCertificazione(courseDataEdit.certificazione);
      }
    }
  }, [courseDataEdit])

  const fetchDocumentiByIdCorso = async () => {
    const obj = {id_corso: courseDataEdit?.id_corso}
    setIsLoadingAllDocuments(true)
    const res = await findDocumentiByIdCorso(obj);
    setIsLoadingAllDocuments(false)
    setFormDataDocument(res);
  }

  useEffect(() => {
    printProgressBar();
  }, [currentPage])
  
  const printProgressBar = () => {
    switch (currentPage) {
      case 1: setPercBar(25)
      break;
      case 2: setPercBar(50)
      break;
      case 3: setPercBar(75)
      break;
      case 4: setPercBar(100)
      break;
      default: setPercBar(25)
      break;
    }
  }
  
  const handleRadioChange = (event) => {
    setModalita(event.target.id);
  };

  const handleTitoloStudioMinmoChange = (event) => {
    setTitoloStudioMinimo(event.target.value);
  };

  const handleTipoCorsoChange = (event) => {
    setTipoCorso(event.target.value)
    setFormData((prevState) => ({ ...prevState, tipo_corso: event.target.value }));
  }
  
  const handleFormChange = e => {
    const { name, value, type } = e.target;
    if (type === 'file') {
      const file = e.target.files[0];
      if (file) {
        setImageBlob(file);
        setImageUrl(URL.createObjectURL(file));
      }
    } else {
      setFormData(prevState => ({ ...prevState, [name]: value }));
    }
  };
  
  
  useEffect(() => {
    if((modalita === "presenza" || modalita === "mista_presenza/telematica") && sedi?.length === 0) {
      fetchAllSedi();
    }
  }, [modalita])
  
  
  const fetchAllSedi = async () => {
    const fetchSedi = await getAllSedi();
    setSedi(fetchSedi);
  }

  const onCreateCorso = async () => {
    const erogazione = UtilityService.formatModalitaErogazione(modalita);
    let obj = {
      tipo_corso: (selectedTipoCorso === "") ? "Nessuna opzione" : selectedTipoCorso,
      titolo_studio_min: selectedTitoloStudioMinimo,
      codice: UtilityService.generateCourseCode(),
    }
    if(obj?.tipo_corso === "Nessuna opzione") {
      delete obj?.tipo_corso;
    }

    obj = {
      ...obj,
      ...formData
    }

    if(!isUpdateMode) {
      obj = {
        ...obj,
        modalita_erogazione: erogazione,
        id_certificazione: selectedCertificazione?.id_certificazione || null
      }
      if(obj?.modalita_erogazione === "Nessun opzione"){
        delete obj?.modalita_erogazione;
      }

      if(obj?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA){
        delete obj?.numero_massimo_corsisti;
      }
      const resCreate = await createCorso(obj, imageBlob);
      if(resCreate?.id_corso) {
        if(formDataDocument?.length > 0) {
          setIsLoadingCreateDocument(true)
          for (let document of formDataDocument) {
            document  = {
              ...document,
              id_corso: resCreate?.id_corso,
              }
              await addDocumentCorsi(document)
            }
              setIsLoadingCreateDocument(false)
          }
          navigate("/gestione-corsi")
          alertService.success("Corso creato con successo", {autoClose: true});
      }
    } else {
      delete formData?.modalita_erogazione;
      obj = {
        ...obj,
        modalita_erogazione: erogazione,
        id_certificazione: selectedCertificazione?.id_certificazione || null
      }
      const resUpdate = await updateCorso(obj, imageBlob);
      if(obj?.modalita_erogazione === "Nessun opzione"){
        delete obj?.modalita_erogazione;
      }
      if(deleteDocumentiList?.length > 0) {
        setIsLoadingDeleteDocument(true)
        for (const document of deleteDocumentiList) {
          const obj = {id_documento: document?.id_documento}
          await deleteDocumentCorsi(obj)
        }
        setIsLoadingDeleteDocument(false)
      }
      if(formDataDocument?.length > 0) {
        setIsLoadingCreateDocument(true)
        for (let document of formDataDocument) {
          if(document?.isNew) {
            document  = {
              ...document,
              id_corso: courseDataEdit?.id_corso,
            }
            await addDocumentCorsi(document)
          }
        }
        setIsLoadingCreateDocument(false)
      }
      if(resUpdate) {
        navigate("/gestione-corsi")
        alertService.success("Corso aggiornato con successo", {autoClose: true});
      }
    }


  }

 const handleNextPage = () => {
      if(currentPage === 1){
         let requiredFields = ["denominazione"];
        if(modalita === "asincrona" || modalita === "sincrona" || modalita === "telematica_mista" || modalita === "presenza" || modalita === "mista_presenza/telematica") {
          requiredFields = [...requiredFields, "durata"];
        }

        const missingFields = UtilityService.validationForm(formData, requiredFields);
        if (missingFields?.length > 0) {
          const formatFields = missingFields?.map(field => {
            let formattedField = field.replace(/_/g, " di ");
            formattedField = formattedField.replace("descrizione", "breve descrizione"); 
            return formattedField;
          });
          const formattedMissingFields = formatFields.join(", ");
          
          alertService.warn(`I seguenti campi sono obbligatori: ${formattedMissingFields}`, {autoClose: true});
          return;
        }

        if(formData?.durata == "0"){
          alertService.warn(`La durata del corso deve essere maggiore di 0`, {autoClose: true});
          return;
        }
      }

      // if(currentPage === 2){
      //   let requiredFields = ["prezzo", "scadenza", "note"];
      //   const missingFields = UtilityService.validationForm(formData, requiredFields);
      //   if (missingFields?.length > 0) {
      //     const formatFields = missingFields?.map(field => {
      //       return field.replace("note", "descrizione"); 
      //     });
      //     const formattedMissingFields = formatFields.join(", ");
      //     alertService.warn(`I seguenti campi sono obbligatori: ${formattedMissingFields}`, {autoClose: true});
      //     return;
      //   }
      // }
    setCurrentPage(currentPage + 1);
   };

  const handlePreviousPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleNumberInput = (e) => {
    e.target.value = e.target.value.replace(/-/g, '');
  };

  const handleCertificazioneSelect = (certificazione) => {
    if (!certificazione || !certificazione?.id_certificazione) {
      return;
    }
    setSelectedCertificazione(certificazione);
  };

  const handleCertificazioneRemove = () => {
    setSelectedCertificazione(null);
  };

  return (
    <div className='row mt-4'>
      {currentPage === 1 && (
        <>
    <div className='col-12 my-2'>
      <span className='small text-muted d-block'><b>Denominazione</b></span>
      <input name="denominazione" value={formData.denominazione || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Denominazione"/>
    </div>
    <div className='col-12 my-2'>
      <span className='small text-muted d-block'><b>Versione</b></span>
      <input name="versione" value={formData.versione || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Versione" maxLength={45}/>
    </div>
      <>
      {
        !isUpdateMode && (
        <div className="col-12 my-2">
          <span className="mt-2 d-block">Scegli la modalità del corso</span>
          <hr />
   {/*        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="modalitaCorso"
            id="nessuna"
            value="nessuna"
            checked={modalita === "nessuna"}
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="sincrona">
            <b>Non specificata:</b> Scegli la modalità del corso in seguito
          </label>
        </div> */}
          <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="modalitaCorso"
            id="sincrona"
            value="sincrona"
            checked={modalita === 'sincrona'}
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="sincrona">
            <b>Telematica sincrona:</b> tutti gli studenti iniziano e finiscono il corso nelle stesse date
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="modalitaCorso"
            id="asincrona"
            value="asincrona"
            checked={modalita === 'asincrona'}
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="asincrona">
            <b>Telematica asincrona:</b> ogni studente inizia il corso in date diverse e finirà quando raggiunge la durata che lui/lei indica sotto
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="modalitaCorso"
            id="presenza"
            value="presenza"
            checked={modalita === 'presenza'}
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="presenza">
            <b>Presenza:</b> tutti gli studenti iniziano e finiscono il corso nelle stesse date in presenza
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="modalitaCorso"
            id="telematica_mista"
            value="telematica_mista"
            checked={modalita === 'telematica_mista'}
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="telematica_mista">
            <b>Telematica mista:</b>  tutti gli studenti iniziano e finiscono il corso nelle stesse date in telematica mista
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="modalitaCorso"
            id="mista_presenza/telematica"
            value="mista_presenza/telematica"
            checked={modalita === 'mista_presenza/telematica'}
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="mista_presenza/telematica">
            <b>Mista presenza/telematica:</b> tutti gli studenti iniziano e finiscono il corso nelle stesse date in presenza/telematica
          </label>
        </div>
      </div>

        )
      }
<div className='row mt-2'>
  {
    modalita !== "asincrona" && (  
    <div className='col-lg-12 col-xl-3'>
      <span className="d-block text-muted"><b>Numero massimo di corsisti</b></span>
      <input type='number' name="numero_massimo_corsisti" value={formData.numero_massimo_corsisti || ''} onChange={handleFormChange} placeholder='Numero massimo di corsisti' className='form-control'/>    
    </div>
  )
  }
    <div className='col-lg-12 col-xl-2'>
    <span className="d-block text-muted"><b>Durata del corso</b></span>
        <div className="d-flex">
          <input name="durata" onInput={handleNumberInput} value={formData.durata || ''} onChange={handleFormChange} type="number" className="form-control" placeholder="Durata" style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}}/>
          <button style={{ cursor: 'default', borderColor: '#ddd'  }} type="button">Ore</button>
        </div>
    </div>
</div>
   </>
{/*    <div className='col-12 mt-2'>
      <span className="d-block text-muted"><b>Tipo di corso</b></span>
        <select
          name="tipo_corso"
          value={formData.tipo_corso || ''}
          onChange={handleTipoCorsoChange}
          className='form-control'
        >
         <option value="">Seleziona il tipo di corso</option>
          <option value="Open">Open</option>
          <option value="A_tempo">A tempo</option>
      </select>
   </div> */}
   <div className='col-12 mt-2'>
      <span className="d-block text-muted"><b>Breve descrizione</b></span>
      <input type='text' name="descrizione" value={formData.descrizione || ''} onChange={handleFormChange} placeholder='Breve descrizione' className='form-control'/>    
   </div>
   <div className='col-12 mt-2'>
    
          <span className="d-block text-muted"><b>Requisiti</b></span>
          {
            !isLoadingAllDocuments ? 
            <RequirementsCourse 
            formDataDocument={formDataDocument}
            setFormDataDocument={setFormDataDocument}
            setDeleteDocumentiList={setDeleteDocumentiList}
            />
            : 
            <>
            <p>Caricando i requisiti...</p>
            <div className='ms-5'>
            <Spinner animation="border" role="status">
            <span className="visually-hidden">Caricamento...</span>
          </Spinner>
            </div>
          </>
          }
       
   </div>
        </>
      )}
{currentPage === 2 && (
        <>
   <div className='col-12 mt-2'>
      <span className="d-block text-muted"><b>Prezzo</b></span>
      <input type='number' name="prezzo" value={formData.prezzo || ''} onChange={handleFormChange} placeholder='Prezzo' className='form-control' />    
   </div>
   <div className='col-12 mt-2'>
      <span className="d-block text-muted"><b>Scadenza</b></span>
      <input type='date' name="scadenza" value={(courseDataEdit?.id_corso ? UtilityService.formatDateFillInput(formData.scadenza) : formData.scadenza) ?? ''} onChange={handleFormChange} className='form-control' />    
   </div>
   <div className='col-12 mt-2'>
     <RichTextEditor
            name="note"
            value={formData.note || ''}
            onChange={handleFormChange}
            label="Descrizione"
            placeholder="Inserisci descrizione"
          />
   </div> 
   <div className='col-12 mt-2'>
   <RichTextEditor
            name="fruizione_corso"
            value={formData.fruizione_corso || ''}
            onChange={handleFormChange}
            label="Fruizione"
            placeholder="Inserisci fruizione"
          />
   </div>
   
   <div className='col-12 mt-2'>
      <RichTextEditor
          name="contratto_formativo"
          value={formData.contratto_formativo || ''}
          onChange={handleFormChange}
          label="Contratto formativo"
          placeholder="Inserisci contratto formativo"
        />
   </div>
   <div className='col-sm-12 col-lg-6 mt-2'>
        <CustomSearch
          field="descrizione"
          label="Seleziona certificazione"
          searchApi={getCertificazioniByParams}
          placeholder="Nome della certificazione"
          setSelectedItem={handleCertificazioneSelect}
        />
        <div className="mt-2">
          {selectedCertificazione && (
            <div className="py-3 my-1 bg-light rounded position-relative">
              <div className="d-flex justify-content-between align-items-center px-3">
                <span className="text-muted">{selectedCertificazione?.descrizione}</span>
                <button 
                  type="button" 
                  className="btn btn-link p-0 text-dark" 
                  onClick={handleCertificazioneRemove}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
        </>
  
      )}
{currentPage === 3 && (
        <>
   <div className='col-12 mt-2'>
  <span className="d-block text-muted"><b>Titolo di studio minimo</b></span>
  <select
    name="titolo_studio_min"
    value={selectedTitoloStudioMinimo}
    onChange={handleTitoloStudioMinmoChange}
    className='form-control'
  >
    {Object.values(TitoloStudioOptions)?.map((option) => (
      <option key={option} value={option}>{option}</option>
    ))}
  </select>
</div>
   <div className='col-12 mt-2'>
      <span className="d-block text-muted"><b>Percentuale assenze massimo</b></span>
      <input type='number' name="perc_assenze_max" value={formData.perc_assenze_max || ''} onChange={handleFormChange} placeholder='Percentuale assenze massimo' className='form-control' />    
   </div>
<div className='col-12 mt-2'>
    {/*   <span className="d-block text-muted"><b>Istruzioni svolgimento corso</b></span> */}
{/*       <textarea name="istruzioni_svolgimento_corso" value={formData.istruzioni_svolgimento_corso || ''} onChange={handleFormChange} placeholder='Istruzioni svolgimento corso' rows={3} className='form-control' />     */}
      <RichTextEditor
          name="istruzioni_svolgimento_corso"
          value={formData.istruzioni_svolgimento_corso || ''}
          onChange={handleFormChange}
          label="Istruzioni svolgimento corso"
          placeholder="Inserisci istruzioni svolgimento corso"
        />
   </div>
   <div className='col-12 mt-2'>
   {/*     <span className="d-block text-muted"><b>Struttura</b></span> */}
{/*       <textarea name="struttura" value={formData.struttura || ''} onChange={handleFormChange} placeholder='Struttura' rows={3} className='form-control' />  */}
      <RichTextEditor
          name="struttura"
          value={formData.struttura || ''}
          onChange={handleFormChange}
          label="Struttura"
          placeholder="Inserisci struttura"
        />
   </div>
   <div className='col-12 mt-2'>
   {/*    <span className="d-block text-muted"><b>Obiettivo</b></span> */}
      {/* <textarea name="obiettivo" value={formData.obiettivo || ''} onChange={handleFormChange} placeholder='Obiettivo' rows={3} className='form-control' />     */}
      <RichTextEditor
        name="obiettivo"
        value={formData.obiettivo || ''}
        onChange={handleFormChange}
        label="Obiettivo"
        placeholder="Inserisci obiettivo"
      />
   </div>
   <div className='col-12 mt-2'>
      {/* <span className="d-block text-muted"><b>Frequenza</b></span> */}
      {/* <textarea name="frequenza" value={formData.frequenza || ''} onChange={handleFormChange} placeholder='Frequenza' rows={3} className='form-control' />     */}
      <RichTextEditor
        name="frequenza"
        value={formData.frequenza || ''}
        onChange={handleFormChange}
        label="Frequenza"
        placeholder="Inserisci frequenza"
      />
   </div>
        </>
      )}
{currentPage === 4 && (
        <>
   <div className='col-12 mt-2'>
      {/* <span className="d-block text-muted"><b>Clausole</b></span> */}
      {/* <textarea name="clausole" value={formData.clausole || ''} onChange={handleFormChange} placeholder='Clausole' rows={3} className='form-control' />     */}
      <RichTextEditor
        name="clausole"
        value={formData.clausole || ''}
        onChange={handleFormChange}
        label="Clausole"
        placeholder="Inserisci clausole"
      />
   </div>
   <div className='col-12 mt-2'>
      {/* <span className="d-block text-muted"><b>Strumenti di supporto</b></span> */}
      {/* <textarea name="strumento_supporto" value={formData.strumento_supporto || ''} onChange={handleFormChange} placeholder='Strumenti di supporto' rows={3} className='form-control' />     */}
      <RichTextEditor
        name="strumento_supporto"
        value={formData.strumento_supporto || ''}
        onChange={handleFormChange}
        label="Strumenti di supporto"
        placeholder="Inserisci strumenti di supporto"
      />
   </div>
   <div className='col-12 mt-2'>
      {/* <span className="d-block text-muted"><b>Esame</b></span> */}
      {/* <textarea name="esame" value={formData.esame || ''} onChange={handleFormChange} placeholder='Esame' rows={3} className='form-control' />     */}
      <RichTextEditor
        name="esame"
        value={formData.esame || ''}
        onChange={handleFormChange}
        label="Esame"
        placeholder="Inserisci esame"
      />
   </div>
   <div className='col-12 mt-2'>
      {/* <span className="d-block text-muted"><b>Istruzioni svolgimento esame</b></span> */}
      {/* <textarea name="istruzioni_svolgimento_esame" value={formData.istruzioni_svolgimento_esame || ''} onChange={handleFormChange} placeholder='Istruzioni svolgimento esame' rows={3} className='form-control' />     */}
      <RichTextEditor
        name="istruzioni_svolgimento_esame"
        value={formData.istruzioni_svolgimento_esame || ''}
        onChange={handleFormChange}
        label="Istruzioni svolgimento esame"
        placeholder="Inserisci istruzioni svolgimento esame"
      />
   </div>
   <div className='col-12 mt-2'>
      <span className="d-block text-muted"><b>Immagine del corso</b></span>
      <input accept="image/jpeg,image/png,image/gif,image/jpg" type='file' name="immagine_corso" value={formData.immagine_corso} onChange={handleFormChange} placeholder='Immagine del corso' className='form-control my-2 rounded' />    
      {imageUrl && (
          <div>
            <img src={`${imageUrl}`} alt="Immagine corso" width={250} height={150} />
          </div>
        )}
   </div>
   </>
      )}
      <div className='col-12 mt-4'>
        {currentPage === 1 && (
          <div className='text-end'>
            <button className='btn btn-primary btn-lg' onClick={handleNextPage}>Avanti</button>
          </div>
        )}
        {currentPage === 2 && (
          <div className='d-flex justify-content-between'>
            <button className='btn btn-secondary btn-lg' onClick={handlePreviousPage}>Indietro</button>
            <button className='btn btn-primary btn-lg' onClick={handleNextPage}>Avanti</button>
          </div>
        )}
        {currentPage === 3 && (
          <div className='d-flex justify-content-between'>
            <button className='btn btn-secondary btn-lg' onClick={handlePreviousPage}>Indietro</button>
            <button className='btn btn-primary btn-lg' onClick={handleNextPage}>Avanti</button>
          </div>
        )}
        {currentPage === 4 && (
          <div className='d-flex justify-content-between'>
            <button className='btn btn-secondary btn-lg' onClick={handlePreviousPage}>Indietro</button>
           
       { !isLoadingCreateDocument && !isLoadingDeleteDocument && !loadingStateCorsi.isLoadingCorsoCreating && !loadingStateCorsi.isLoadingCorsoUpdate && !loadingStateCorsi.isLoadingUploadImgCorsoCreating && !loadingStateCorsi.isLoadingCorsoById? 
       (
         <button className='btn btn-primary btn-lg' onClick={onCreateCorso}>{isUpdateMode ? "Modifica corso" : "Crea corso"}</button>
       ) : (
        <button disabled className='btn btn-primary btn-lg'>
          <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
          />
          {isUpdateMode ? "Modifica corso" : "Crea corso"}
          </button>
       )}
          </div>
        )}
      </div>
    </div>
  );

};

export default CreateCorsoForm;

